import * as React from 'react'

import { TSpecialColorKey } from '~theme/typings'
import { Icon } from '~ui/components/icons/Icon'
import { IconCheckMark } from '~ui/components/icons/specific/IconCheckMark'
import { IconX } from '~ui/components/icons/specific/IconX'
import { GridCentered } from '~ui/components/layout/Box'

type TProps = RequiredChildren & {
  type: ExtractSafe<TSpecialColorKey, 'success' | 'error'>
}

const DIMENSIONS = `4rem`
const ICON_SIZE = `3rem`

/**
 * Success/Error message with the icon, a `heading` & an _optional_ `message`.
 */
export const Result: React.FC<TProps> = ({ type, children }) => {
  return (
    <GridCentered rowGap={`large`}>
      <GridCentered
        radius={`round`}
        width={DIMENSIONS}
        height={DIMENSIONS}
        bgColor={`specialColors.${type}`}
      >
        <Icon icon={type === `success` ? IconCheckMark : IconX} iconSize={ICON_SIZE} />
      </GridCentered>

      <GridCentered rowGap={`smallMedium`} maxWidth={`430px`}>
        {children}
      </GridCentered>
    </GridCentered>
  )
}
